/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 13:48:18
 * @LastEditTime: 2022-04-20 17:03:36
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionDetail/UserInformation/index.tsx
 */
import { Input, RadioGroup, RadioItem } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';

import { IInviteUserType } from '@/src/types/common/permission';
import { MobileNumberAreaInfo } from '@/src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import css from '../style.module.less';
//import { useRequest } from 'ahooks';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
//import { getAreaCodeAll } from 'src/request/common';
import { i18nGet } from 'src/tools/tools';

const UserInformation = ({ disabled, name, email, mobile }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //const { data: areaCodes = [] } = useRequest(() => getAreaCodeAll());
  // const areaCodesOptions = areaCodes.map((item) => ({
  //   label: `+ ${item.areaCode}`,
  //   value: item.areaCode,
  //   uuid: item.uuid,
  // }));
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('usersAndPermissions.detail.userInformation')}>
      {!disabled && (
        <Form.Item
          labelCol={{ span: 24 }}
          initialValue={IInviteUserType.Email}
          label={getI18n('usersAndPermissions.detail.inviteUserBy')}
          name='inviteUserType'>
          <RadioGroup className={css.inviteUserType}>
            <RadioItem value={IInviteUserType.Email}>
              {getI18n('general.email')}
            </RadioItem>
            <RadioItem value={IInviteUserType.Mobile}>
              {getI18n('general.mobile')}
            </RadioItem>
          </RadioGroup>
        </Form.Item>
      )}
      {!disabled && (
        <Form.Item
          shouldUpdate={(prevValues, curValues) =>
            prevValues.inviteUserType !== curValues.inviteUserType
          }>
          {({ getFieldValue }: any) =>
            getFieldValue('inviteUserType') === IInviteUserType.Email ? (
              <Form.Item
                className={css.formItem}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    type: 'email',
                    message: getI18n('general.invalidformat'),
                  },
                ]}
                label={`${getI18n('general.email')}*`}
                name='email'>
                <Input size='large' />
              </Form.Item>
            ) : (
              <Form.Item
                className={css.formItem}
                labelCol={{ span: 24 }}
                label={`${getI18n('general.mobile')}*`}
                name='mobile'>
                <MobileNumberAreaInfo />
              </Form.Item>
            )
          }
        </Form.Item>
      )}
      {disabled && (
        <Fragment>
          <div>
            <h4>{getI18n('usersAndPermissions.detail.name')}</h4>
            <p>{name || '-'}</p>
          </div>
          <div>
            <h4>{getI18n('general.email')}</h4>
            <p>{email || '-'}</p>
          </div>
          <div>
            <h4>{getI18n('general.mobile')}</h4>
            <p>{mobile || '-'}</p>
          </div>
        </Fragment>
      )}
    </SectionWrapper>
  );
};

export default UserInformation;
